"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMIT_DATE = exports.COMMIT_AUTHOR = void 0;
const COMMIT_AUTHOR = 'commit_author';
exports.COMMIT_AUTHOR = COMMIT_AUTHOR;
const COMMIT_DATE = 'commit_date';
exports.COMMIT_DATE = COMMIT_DATE;